<template>
  <component v-bind:is="component"></component>
</template>
<script>
import cumplimiento from "./cumplimiento.vue";
import industria from "./industria.vue";
import antifraude from "./antifraude.vue";
import prevencion from "./prevencion.vue";
import portaletico from "@/views/suite/portaletico.vue";
export default {
  name: "suite",
  data() {
    return {
      component: this.$router.currentRoute.params.name,
    };
  },
  components: { cumplimiento, industria, antifraude, prevencion, portaletico },
};
</script>
